import {
  GeneralDataTypes, HeaderFooterDataTypes, ErrorPageData, Section,
  IRequestDemo,
  IRequestFreeTrial
} from './types';

import axiosInstance from 'services/common/instance';

export const getHeaderFooterService = async (): Promise<HeaderFooterDataTypes> => {
  const res = await axiosInstance.get('systems/header-footer');
  return res.data?.data;
};

export const getGeneralService = async (): Promise<GeneralDataTypes> => {
  const res = await axiosInstance.get('systems/general');
  return res.data?.data;
};

export const getPageErrorService = async (): Promise<APIResponse<ErrorPageData>> => {
  const response = await axiosInstance.get('systems/errors-pages');
  return response.data;
};

export const getPackageCompareService = async (): Promise<Section[]> => {
  const res = await axiosInstance.get('systems/general');
  return res.data.data.others.servicePackageCollaborate;
};

export const requestDemoService = async (data: IRequestDemo): Promise<IRequestDemo> => {
  const response = await axiosInstance.post('demo-subscribe', data);
  return response.data.data;
};

export const requestFreeTrialService = async (
  data: IRequestFreeTrial
): Promise<IRequestFreeTrial> => {
  const response = await axiosInstance.post('checkout/free-trial', data);
  return response.data.data;
};
